<template>
  <div class="app-autocomplete">
    <label class="app-autocomplete__main">
      <app-title-box
        v-if="title"
        class="app-input-control__title"
        :class="titleClass"
        size="small"
        :title="title"
        :isTooltip="!!tooltip"
        :tooltip="tooltip"
        :isRequired="isRequired"
      ></app-title-box>
      <autocomplete
        :placeholder="placeholder"
        :search="search"
        :debounceTime="debounceTime"
        :defaultValue="defaultValue"
        :getResultValue="getResultValue"
        baseClass="app-autocomplete__autocomplete"
        @update="handleUpdate"
        @submit="handlerSubmit"
        @input="handleInput"
        @blur="handleBlur"
        :value="innerValue"
        @keydown.enter.prevent="handleKeyDown"
        ref="autocomplete"
      ></autocomplete>
    </label>
  </div>
  <!-- <autocomplete
    :placeholder="placeholder"
    :search="search"
    :debounceTime="debounceTime"
    :defaultValue="defaultValue"
    :getResultValue="getResultValue"
    baseClass=""
    @update="handleUpdate"
    @submit="handlerSubmit"
    @input="handleInput"
    ref="autocomplete"
    class="app-autocomplete"
  >
    <template
      #default="{
        rootProps,
        inputProps,
        inputListeners,
        resultListProps,
        resultListListeners,
        results,
        resultProps,
      }"
    >
      <label v-bind="rootProps" class="app-autocomplete__main">
        <app-title-box
          v-if="title"
          class="app-input-control__title"
          :class="titleClass"
          size="small"
          :title="title"
          :isTooltip="!!tooltip"
          :tooltip="tooltip"
          :isRequired="isRequired"
        ></app-title-box>
        <input
          v-bind="inputProps"
          v-on="inputListeners"
          :class="[
            'app-autocomplete__input',
            { 'app-autocomplete__input--no-results': noResults },
            { 'app-autocomplete__input--focused': focused },
          ]"
          @focus="handleFocus"
          @blur="handleBlur"
          @keydown.stop="inputListeners.keydown"
          @input="$refs.autocomplete.handleInput($event)"
        />
        <ul
          v-if="noResults && isNoResults"
          class="app-autocomplete__result-list app-autocomplete__result-list--no-results"
          style="position: absolute; top: 100%; z-index: 1"
        >
          <li
            class="app-autocomplete__result app-autocomplete__result--no-results"
          >
            Ничего не найдено
          </li>
        </ul>
        <ul
          class="app-autocomplete__result-list"
          v-bind="resultListProps"
          v-on="resultListListeners"
        >
          <li
            v-for="(result, index) in results"
            :key="resultProps[index].id"
            v-bind="resultProps[index]"
            class="app-autocomplete__result"
          >
            {{ result }}
          </li>
        </ul>
      </label>
    </template>
  </autocomplete> -->
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue';

export default {
  name: 'AppAutocomplete',
  components: {
    Autocomplete,
    AppTitleBox: () => import('@/components/common/AppTitleBox'),
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    isNoResults: {
      type: Boolean,
    },
    tooltip: {
      type: String,
      default: '',
    },
    isRequired: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    /**
     * Подсказки
     */
    suggests: {
      type: Array,
      default() {
        return [];
      },
    },
    /**
     * Начальное значение компонента
     */
    defaultValue: {
      type: String,
      default: '',
    },
    /**
     * Время в миллисекундах, в течение которого компонент должен ждать
     */
    debounceTime: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    innerValue: '',
    focused: false,
    results: [],
  }),
  computed: {
    noResults() {
      return this.value && this.results.length === 0;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.innerValue = value;
      },
    },
    innerValue(value) {
      this.$emit('input', value);
    },
  },
  methods: {
    /**
     * событие focus
     */
    handleFocus() {
      this.focused = true;
    },
    /**
     * событие blur
     */
    handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
    },
    /**
     * @param event
     */
    handleInput(event) {
      this.innerValue = event.target.value;
    },
    /**
     * Событие update компонента autocomplete
     */
    handleUpdate() {
      // event
    },
    /**
     * событие нажатия на клавиши
     */
    handleKeyDown(event) {
      return event;
    },
    /**
     * Событие submit компонента autocomplete
     */
    handlerSubmit(event) {
      if (event) {
        this.innerValue = event;
      }
    },
    /**
     * Функция поиска, выполняемая при вводе пользователем.
     * @returns array & object
     */
    search(input) {
      if (input.length < 1) {
        this.results = [];
        return this.results;
      }
      this.results = this.suggests.filter((suggest) => {
        return suggest.toLowerCase().includes(input.toLowerCase());
      });
      return this.results;
    },
    /**
     * Если объект
     * @param result
     */
    getResultValue(result) {
      return result;
    },
    /**
     * Очистка значений
     */
    clear() {
      this.innerValue = '';
      this.$refs.autocomplete.value = '';
    },
  },
};
</script>

<style lang="scss">
.app-autocomplete {
  $root: &;

  position: relative;
  width: 100%;

  &__main {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 7px 12px;
    cursor: text;
    background: $white;
    border: 1px solid $gray-light;
    border-radius: 2px;
    transition: border $A;

    &:hover {
      border-color: $color-brand-green;
    }

    &--focused {
      border-color: $color-brand-green;
    }
  }
  // TODO: вынести в css блок autocomplete
  &__autocomplete-input {
    width: 100%;
    font-size: rem(14);
    font-weight: 250;
    line-height: 18px;
    color: $black;
    letter-spacing: 0.02em;
    background-color: $color-transparent;
    border: 0;

    &::placeholder {
      color: $gray-dark;
    }

    &:disabled {
      background: $white;
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px $color-white inset !important;
    }
  }

  &__autocomplete {
    position: static !important;
  }

  &__autocomplete-input--no-results {
    // -
  }

  &__autocomplete-input--focused {
    // -
  }

  &__autocomplete-result-list {
    @include list-reset;

    left: -1px;
    z-index: 10 !important;
    box-sizing: border-box;
    width: calc(100% + 2px) !important;
    max-height: 338px;
    overflow-y: auto;
    background-color: $white;
    border: 1px solid $gray-light;
  }

  &__autocomplete[data-position='above'] &__autocomplete-result-list {
    margin-bottom: 1px;
    border-bottom-color: transparent;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    box-shadow: 0 -10px 20px rgba(0, 0, 0, 0.25);
  }

  &__autocomplete[data-position='below'] &__autocomplete-result-list {
    margin-top: 1px;
    border-top-color: transparent;
    border-bottom-right-radius: 2px;
    border-bottom-left-radius: 2px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.25);
  }

  &__autocomplete-result {
    min-height: 1px;
    padding: 12px 25px 12px 25px;
    font-size: rem(13);
    font-weight: normal;
    color: $black;
    white-space: normal;
    cursor: pointer;
    background: $white;
    transition: background-color $A;

    &:hover,
    &[aria-selected='true'] {
      background: #f4f4f4;
    }
  }

  &__autocomplete-result--no-results {
    cursor: default;
    background: $white;

    &:hover,
    &[aria-selected='true'] {
      background: $white;
    }
  }
}
</style>
